import { createMutation } from "@/mutations";
import { deleteSearchHistory } from "@/features/search/api/search";
import type { RecentSearch } from "@/types/searchItemsTypes";

export const useDeleteSearchHistoryMutation = () => {
  return createMutation<void, RecentSearch["id"][]>({
    mutationFn: async (ids) => {
      await deleteSearchHistory(ids);
    },
    invalidateQueries: (key) => Array.isArray(key) && key[0] === "search" && key[1] === "history",
  });
};

